import React, { useId } from 'react';
import './style.scss';

type ToggleSwitchProps = {
  readonly label: string;
  readonly isOn: boolean;
  readonly onChange: () => void;
};

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  label,
  isOn,
  onChange,
}) => {
  const switchId = useId();

  return (
    <div className="xa-toggle-switch">
      <input
        type="checkbox"
        id={switchId}
        checked={isOn}
        onChange={onChange}
      />
      <label htmlFor={switchId}>{label}</label>
    </div>
  );
};

export default ToggleSwitch;
